import { Paper } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
	sx?: SxProps<Theme>;
	children: ReactNode;
};

// Filter card of every title + filters + list page: a fixed-height band, so the list below starts
// at the same spot on every page and only the controls inside change
export const FilterPaper = ({ sx, children }: Props) => (
	<Paper
		elevation={1}
		sx={[
			{
				minHeight: 72,
				px: 2,
				py: 0.5,
				display: "flex",
				alignItems: "center",
				borderRadius: "0.75rem",
				boxSizing: "border-box",
				"& > *": { flex: 1, minWidth: 0 },
			},
			...(Array.isArray(sx) ? sx : [sx]),
		]}
	>
		{children}
	</Paper>
);
